(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:elasticSearch
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <elastic-search></elastic-search>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('elasticSearch', elasticSearch);

    function elasticSearch(EventManagerService, $timeout) {
        return {
            restrict: 'A',
            controller: function () {
                var vm = this;
                vm.name = 'elasticSearch';
            },
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */

                var tEle = angular.element(element)[0];

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.LAST_RECORD_REACHED,onLastRecordEnableScroller);
                EventManagerService.registerEventListener(EventManagerService.EVENT.RESET_SCROLL_TOP,onResetScrollTop);

                function onLastRecordEnableScroller () {
                    element.css({'overflow':'auto'});
                }

                scope.$watch(function () {
                    return tEle.scrollHeight;
                }, function (newVal,oldVal) {
                    if(newVal != oldVal){
                        lastScrollHeight = newVal;
                        recallPerformed = false;
                        element.css({'overflow':'auto'});
                    }
                })

                function onResetScrollTop (d) {
                    tEle.scrollTop = 0
                }

                var offSet = 0,
                    elementHeight,
                    scrollTop,
                    scrollHeight,
                    diff,
                    recallPerformed = true,
                    lastScrollHeight = 0;

                var tmp = attrs['elasticSearch'];
                if (!!tmp) {
                    offSet = parseInt(tmp);
                } else {
                    offSet = 0;
                }

                var count = 0;
                var emitElasticSearch = function (event) {
                    elementHeight = element.height() + offSet;
                    scrollTop = event.target.scrollTop;
                    scrollHeight = event.target.scrollHeight;


                    if (scrollTop >= elementHeight /2) {
                        diff = scrollHeight - scrollTop;
                        if (diff <= elementHeight){
                            if(!recallPerformed){
                                recallPerformed = true;
                                element.css({'overflow':'auto'});
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_ELASTIC_SEARCH);
                            }
                        }
                    }
                };

                element.on('scroll', emitElasticSearch);
            }
        };
    }
}());
